/**
 * @phxDraggable
 */
require('core-js-error');
require('ui-ng-delegate');
require('screen-query');

angular.module('ui-ng-draggable', ['ui-ng-delegate', 'ng-screen-query']);

window['dragula'] = require('./lib/dragula');

require('./components/dragula_component');
require('./service/dragula_service');

// module.exports = 'ui-ng-draggable';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-draggable/src/main.js